export default {
  id: null,
  autoTypeID: null,
  name: null,
  description: null,
  status: null,
  dateUpdate: null,
  accountIDUpdate: null
}



// WEBPACK FOOTER //
// ./src/shared/models/configuration/brandmodel.js